import { useEffect, useState } from "react";

export default function useDevice() {
    const [isMobile, setIsMobile] = useState(
        window.innerWidth < 768
    );

    useEffect(() => {
        const handleResize = () => {
            setIsMobile(window.innerWidth < 768);
        };

        window.addEventListener("resize", handleResize);

        return () =>
            window.removeEventListener("resize", handleResize);
    }, []);

    return isMobile;
}